import styled from "@emotion/styled";
import { E164Number } from "libphonenumber-js";
import React from "react";
import { Control, Controller, ControllerRenderProps, FieldValues, Path } from "react-hook-form";
import PhoneInput from "react-phone-number-input/input";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { baseInputCss } from "./Question";
import QuestionWrapper from "./QuestionWrapper";

interface Props<$FieldValues extends FieldValues> {
  name: Path<$FieldValues>;
  defaultValue?: string;
  control: Control<$FieldValues>;
  autoFocus: boolean;
  disabled: boolean;
  placeholder?: string;
  inputRef?: React.Ref<HTMLInputElement>;
}

export const StyledPhoneInput = styled(PhoneInput)`
  ${baseInputCss}
`;

function QuestionPhoneNumberInput<$FieldValues extends FieldValues>(props: Props<$FieldValues>) {
  const handleChange = (field: ControllerRenderProps<$FieldValues>, value?: E164Number) => {
    field.onChange(value ?? "");
  };

  return (
    <QuestionWrapper>
      <Controller
        render={({ field }) => (
          <StyledPhoneInput
            country="US"
            role="textbox"
            maxLength={14}
            {...props}
            placeholder={props.placeholder ?? translate(STRINGS.ENTER_NUMBER_HERE)}
            {...field}
            onChange={(value) => handleChange(field, value)}
            ref={props.inputRef}
          />
        )}
        control={props.control}
        name={props.name}
      />
    </QuestionWrapper>
  );
}

export default QuestionPhoneNumberInput;
